import { DepartmentType } from "@/features/BookingCard/__generated__/BookingCard_Booking.graphql";
import { FacilityType } from "@/features/Department/hooks/__generated__/useDepartmentMaxGolfCourseBookingWindow_department.graphql";

export const validMixpanelEnvs = ["prod", "demo", "local"];
export namespace Analytics {
  export namespace Bookings {
    export type BookingAnalyticsData = {
      clubId: string;
      clubSlug: string;
      bookingId?: string;
      bookingIds?: string[];
      orderId?: string;
      transactionId?: string;
      value?: number;
      currency?: string;
      bookingStatus: "UNKNOWN" | "DRAFT" | "CONFIRMED";
      isRequest: boolean;
      bookingType: "STANDARD" | "LESSON" | "DINING";
      facilityType?: FacilityType;
      bookingDepartmentType?: DepartmentType;
      isPublicBooking: boolean;
      paymentInformation: PublicPaymentInformation | PrivatePaymentInformation;
      playerInformation: PublicBookingInformation | PrivateBookingInformation;
      isGolf: boolean;
      activityTypeMetadata:
        | GolfBookingInformation
        | ActivityManagementBookingInformation
        | DiningBookingInformation;
    } | null;

    //Player Information
    export type PublicBookingInformation = {
      playerCount: number;
      knownCustomerCount: number;
      unknownCustomerCount: number;
    };

    export type PrivateBookingInformation = {
      playerCount: number;
      knownMemberCount: number;
      unknownMemberCount: number;
      knownGuestCount: number;
      unknownGuestCount: number;
    };

    //Activity Type Metadata
    export type GolfBookingInformation = {
      holeCounts: { 9: number; 18: number };
      transportation: {
        CADDIE: number;
        CADDIE_CART: number;
        CART: number;
        FULL_CART: number;
        MOTOR_PULL_CART: number;
        PULL_CART: number;
        PRIVATE_CART: number;
        SINGLE_CART: number;
        WALK: number;
        OTHER: number;
      };
    };

    export type ActivityManagementBookingInformation = {
      duration: number;
    };

    export type DiningBookingInformation = {
      partySize: number | null;
      dietaryTags: string[];
      occasionTags: string[];
      notesFromMember: string | null;
    };

    //Payment Information
    export type PublicPaymentInformation = {
      requiresPrePayment: "FULL" | "COLLECT_CARD_ON_FILE" | "NONE" | "UNKNOWN";
      whooshBookingFee: number;
      whooshRoundFee: number;
    };

    //For now we aren't tracking private payment info. But we could easily extend to
    //tracking how many guests are paying etc.
    export type PrivatePaymentInformation = null;
  }
  export namespace Profile {
    export type ProfileAnalyticsData = null | {};
  }
  export namespace TeeSheet {
    export type TeeSheetAnalyticsData = {
      queueSlotId: string;
      time?: string;
    };
  }
  export namespace Agenda {
    export type AgendaAnalyticsData = {
      queueSlotId: string;
    };
  }
  export namespace BookingDetail {
    export type BookingDetailAnalyticsData = {
      requestBookingId: string;
    };
  }
}
